import { Navigate, useParams } from 'react-router-dom';
import { APP_LINKS } from '@/helpers/links';
import ReportingModesPageV1 from './versions/v1';

const VERSIONS = ['v1'];

const ReportingModesPage = () => {
  const { version } = useParams();

  if (version && !VERSIONS.includes(version)) {
    return <Navigate to={APP_LINKS.loanTermsReportingModes()} replace />;
  }

  switch (version) {
    case 'v1':
    default:
      return <ReportingModesPageV1 />;
  }
};

export default ReportingModesPage;
